import { WallboxChargingModel } from '../models'

const isSameSession = (event: WallboxChargingModel, chargingModel: WallboxChargingModel): boolean => {
  if (event.sessionId && chargingModel.sessionId) return event.sessionId === chargingModel.sessionId

  if (event.wallboxId && chargingModel.wallboxId) return event.wallboxId === chargingModel.wallboxId

  return false
}

export const removeFinishedSession = (previous: WallboxChargingModel[], chargingModel: WallboxChargingModel): WallboxChargingModel[] =>
  previous.filter(event => !isSameSession(event, chargingModel))

/**
 * Adds or updates a charging session in the active sessions list.
 *
 * If a session matching the given chargingModel (by sessionId or wallboxId) exists,
 * it updates that session with the new data. Otherwise, it adds the new session.
 *
 * @param previous - The current list of active sessions
 * @param chargingModel - The session to add or update
 * @returns Updated list of active sessions
 */
export const upsertActiveSession = (previous: WallboxChargingModel[], chargingModel: WallboxChargingModel): WallboxChargingModel[] => {
  /* Find if the session already exists (by sessionId or wallboxId) */
  const existingIndex = previous.findIndex(event => isSameSession(event, chargingModel))

  /* If not found, add as new session */
  if (existingIndex === -1) return [...previous, chargingModel]

  /* If found, update the existing session with new data */
  const next = [...previous]
  next[existingIndex] = { ...next[existingIndex], ...chargingModel }
  return next
}
